import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { localize } from '../../i18n/locale';
import { trackEvent } from '../../utils/analytics';

const Intro = () => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const tr = (ko, en) => localize(i18n.resolvedLanguage || i18n.language, { ko, en });
    const handleStart = () => {
        trackEvent('feature_selected', {
            feature_name: 'chugumi',
            source_page: 'chugumi_intro',
        });
        navigate('/chugumi-test/q/1');
    };

    return (
        <div className="chugumi-container">
            <div className="intro-card">
                <div className="icon-wrapper">
                    <span className="main-icon">✨</span>
                </div>
                <h1>{tr('추구미 성향 분석', 'Chugumi Preference Analysis')}</h1>
                <p className="subtitle">
                    {tr('내가 무의식적으로 추구하는 이미지는 무엇일까요?', 'What image do you unconsciously pursue?')}<br />
                    {tr("간단한 질문을 통해 당신의 '추구미'를 찾아드립니다.", 'A short test reveals your preferred aesthetic identity.')}
                </p>

                <div className="feature-list">
                    <div className="feature-item">
                        <span className="feature-icon">🔍</span>
                        <span>{tr('숨겨진 취향 발견', 'Discover hidden preferences')}</span>
                    </div>
                    <div className="feature-item">
                        <span className="feature-icon">💇‍♂️</span>
                        <span>{tr('어울리는 스타일 추천', 'Get matching style suggestions')}</span>
                    </div>
                </div>

                <button className="start-btn" onClick={handleStart}>
                    {tr('테스트 시작하기', 'Start Test')}
                </button>
            </div>

            <style jsx>{`
                .chugumi-container {
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 1rem;
                    background: linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%);
                    color: white;
                }

                .intro-card {
                    background: rgba(255, 255, 255, 0.05);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 24px;
                    padding: 3rem 2rem;
                    text-align: center;
                    max-width: 480px;
                    width: 100%;
                    box-shadow: 0 20px 40px rgba(0,0,0,0.3);
                    animation: fadeIn 0.8s ease-out;
                }

                .icon-wrapper {
                    margin-bottom: 2rem;
                    animation: float 3s ease-in-out infinite;
                }

                .main-icon {
                    font-size: 5rem;
                    filter: drop-shadow(0 0 20px rgba(255,255,255,0.3));
                }

                h1 {
                    font-size: 2.5rem;
                    font-weight: 800;
                    margin-bottom: 1rem;
                    background: linear-gradient(to right, #fff, #94a3b8);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                .subtitle {
                    color: #94a3b8;
                    line-height: 1.6;
                    margin-bottom: 3rem;
                    font-size: 1.1rem;
                }

                .feature-list {
                    display: flex;
                    justify-content: center;
                    gap: 1.5rem;
                    margin-bottom: 3rem;
                }

                .feature-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 0.5rem;
                    font-size: 0.9rem;
                    color: #cbd5e1;
                }

                .feature-icon {
                    font-size: 1.5rem;
                    background: rgba(255,255,255,0.1);
                    padding: 0.75rem;
                    border-radius: 50%;
                }

                .start-btn {
                    background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
                    color: white;
                    border: none;
                    padding: 1.25rem 3rem;
                    font-size: 1.2rem;
                    font-weight: 700;
                    border-radius: 100px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 10px 20px rgba(59, 130, 246, 0.3);
                    width: 100%;
                }

                .start-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 15px 30px rgba(59, 130, 246, 0.4);
                }

                @keyframes float {
                    0% { transform: translateY(0px); }
                    50% { transform: translateY(-10px); }
                    100% { transform: translateY(0px); }
                }

                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </div>
    );
};

export default Intro;
